import * as React from 'react';
import { Tooltip } from "../..";
import { InlineFieldAction } from "./InlineFieldAction";

var InlineFieldInfoAction = function InlineFieldInfoAction(_ref) {
  var info = _ref.info;
  return /*#__PURE__*/React.createElement(Tooltip, {
    tooltip: info,
    shouldWrapChildren: true,
    delay: 400
  }, /*#__PURE__*/React.createElement(InlineFieldAction, {
    icon: "information"
  }));
};

export { InlineFieldInfoAction };
export default InlineFieldInfoAction;